// extracted by mini-css-extract-plugin
export default {"innerSwitcher":"InnerSwitcher_innerSwitcher__iotEm","checked":"InnerSwitcher_checked__2P9M-"};